import React, { FunctionComponent } from 'react';
import '../scss/_customValidationMessage.scss';

export const CustomValidationMessage: FunctionComponent<{
    children: any;
    additionalMessage?: string;
}> = ({ children, additionalMessage }) => {
    return (
        <div
            data-validation-additional-message={additionalMessage}
            className='customValidationMessage-requirements'
        >
            {children}
        </div>
    );
};
